<template>
  <div v-if="!loading && !error" class="fou-dashboard-articles">
    <!-- top highlighted cms content -->
    <div v-if="mainArticles?.length" class="fou-dashboard-articles__featured">
      <!-- content -->
      <div class="fou-dashboard-articles__featured__block">
        <!-- iteration -->
        <div
          v-for="(article, index) in mainArticles"
          :key="article.title"
          class="fou-dashboard-articles__featured__block__content"
          :style="getBackgoundImage(article.variable_media_image.image.image, index !== 0 ? Common.CMS_IMAGE_DIMENSIONS.feature_block_side_image : Common.CMS_IMAGE_DIMENSIONS.feature_block_main_image)"
        >
          <div class="fou-dashboard-articles__featured__block__content__info" @click="redirectToCMSPage(article.variable_media_image.cta_link, 'video')">
            <div class="fou-dashboard-articles-featured-content">
              <!-- label -->
              <p
                class="fou-dashboard-articles__featured__block__content__info__subtitle"
                v-html="$sanitize(article.variable_media_image.sub_title)"
              />
              <h4
                data-qa-id="variable-media-image-title"
                class="fou-dashboard-articles__featured__block__content__info__title"
              >
                <!-- small content title -->
                <a v-if="index !== 0" :href="sanitizedUrl(article.variable_media_image.cta_link)" target="_blank" rel="noopener">
                  {{ article.variable_media_image.title }}
                </a>
                <!-- big content title -->
                <span v-else>
                  {{ article.variable_media_image.title }}
                </span>
              </h4>
              <!-- big content bottom desc -->
              <div class="artile-btn-wrap">
                <MdButton class="dashboard_readmore_btn">
                  <a class="readmore_text" :href="sanitizedUrl(article.variable_media_image.cta_link)" target="_blank" rel="noopener">{{
                    article.variable_media_image.cta_text
                  }}</a>
                </MdButton>
                <p
                  class="fou-dashboard-articles__featured__block__content__info__desc"
                  v-html="$sanitize(Misc.truncate(article.variable_media_image.description,130))"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- buttom cms content list -->
    <div v-if="secondaryArticles?.length" class="fou-dashboard-articles__content">
      <!-- title -->
      <h2 data-qa-id="highlight-media-label-text" class="fou-dashboard-articles__content__title">
        {{ data.data.highlight_media_label_text }}
      </h2>
      <!-- list iteration -->
      <div v-for="article in secondaryArticles" :key="article.title" class="fou-dashboard-articles__content__block">
        <div class="fou-articles-content">
          <!-- image -->
          <div
            class="fou-articles-content__image"
            :style="getBackgoundImage(article.variable_media_image.image.image, Common.CMS_IMAGE_DIMENSIONS.article_content)"
            @click="redirectToCMSPage(article.variable_media_image.cta_link, 'article')"
          />
          <!-- description -->
          <div class="fou-articles-content__text">
            <!-- text -->
            <div class="fou-articles-content__text__para">
              <p
                class="fou-articles-content__text__para__subtitle"
                v-html="$sanitize(article.variable_media_image.sub_title)"
              />
              <h4 class="fou-articles-content__text__para__title" @click="redirectToCMSPage(article.variable_media_image.cta_link, 'article')">
                {{ article.variable_media_image.title }}
              </h4>
              <p
                class="fou-articles-content__text__para__desc"
                v-html="$sanitize(Misc.truncate(article.variable_media_image.description,160))"
              />
            </div>
            <!-- readmore -->
            <div class="fou-articles-content__text__cta">
              <a
                class="fou-articles-content__text__cta__btn"
                :href="sanitizedUrl(article.variable_media_image.cta_link)"
                target="_blank" rel="noopener"
                @click="redirectToCMSPage(article.variable_media_image.cta_link, 'article'); $event.preventDefault()"
              >
                {{ article.variable_media_image.cta_text }}
                <MdIconArrowLong class="cta-icon" rotate="up-right" size="small"></MdIconArrowLong>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./script.js"></script>
